export default {
	getHeaders(role) {
		if (role === "admin") {
			return {
				field: [
					{ field: "time", 							title: "dateTimeEvent" },
					{ field: "orderId", 						title: "order" },
					{ field: "user", 							title: "user" },
					{ field: "event", 							title: "typeEvent" },
				],
			}
		}
	}
}
